var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container flex flex-col"},[_c('PracticeList',{attrs:{"page-size":25},on:{"updated-practice-list":_vm.updatePracticeList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }